import { useEffect, useState } from "react";
import {
  Divider,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { FaWhatsapp } from "react-icons/fa";
import useApi from "../hooks/useApi";

// Feature 12: opt-in de avisos por WhatsApp. Solo reciben mensajes los
// usuarios que registran su número Y activan el switch.
// `titulo`/`descripcion` permiten reusarlo con otro texto (p. ej. el admin,
// que aquí activa los avisos de registros nuevos y difusores por verificar).
export default function WhatsappConfig({ showSnack, titulo, descripcion }) {
  const { loadApi, loadingApi } = useApi();
  const [numero, setNumero] = useState("");
  const [habilitado, setHabilitado] = useState(false);

  useEffect(() => {
    loadApi("user/whatsapp", true, "get")
      .then((res) => {
        setNumero(res.data.numero || "");
        setHabilitado(Boolean(res.data.habilitado));
      })
      .catch(() => {});
  }, []);

  const guardar = () => {
    loadApi("user/whatsapp", true, "put", { numero, habilitado })
      .then((res) => {
        showSnack(res.data.message);
      })
      .catch((e) => {
        showSnack(e.message, "error");
      });
  };

  return (
    <>
      <Divider sx={{ my: 4 }} />
      <Stack gap={1} alignItems="flex-start">
        <Stack direction="row" alignItems="center" gap={1}>
          <FaWhatsapp color="#25D366" fontSize="24px" />
          <Typography variant="h5" fontWeight={600}>
            {titulo || "Avisos por WhatsApp"}
          </Typography>
        </Stack>
        <Typography variant="body2" color="GrayText">
          {descripcion ||
            "Recibe los avisos importantes (nuevas canciones, aprobaciones y mensajes del equipo) directamente en tu WhatsApp. Solo se envían si tú lo activas aquí."}
        </Typography>
        <TextField
          label="Número con lada internacional"
          placeholder="Ej. 5215512345678"
          value={numero}
          onChange={(e) => setNumero(e.target.value.replace(/\D/g, ""))}
          sx={{ minWidth: { xs: "100%", sm: "320px" } }}
          inputProps={{ maxLength: 15 }}
        />
        <FormControlLabel
          control={
            <Switch
              checked={habilitado}
              onChange={(e) => setHabilitado(e.target.checked)}
              color="success"
            />
          }
          label="Recibir avisos por WhatsApp"
        />
        <LoadingButton
          loading={loadingApi.includes("put__user/whatsapp")}
          onClick={guardar}
        >
          Guardar
        </LoadingButton>
      </Stack>
    </>
  );
}
